exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#membership-transaction-form-table {\n  width: 95%;\n}\n#membership-transaction-form-table tbody tr td:nth-child(2) {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n#membership-transaction-form-table .error-span {\n  font-size: 80%;\n  color: red;\n}", ""]);

// exports
